module.exports = __webpack_public_path__ + "img/Back_black.235814a4.svg";